import script from "./campoSeparadorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./campoSeparadorForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__